import { ActionIcon, Button } from '@qred/components-library';
import React, { useRef, useState } from 'react';
import { menuOpenButton } from '~/constants/cy/shared';
import MenuItems from './MenuItems';
import { MainMenuContainer } from './StyledComponentsMenu';
import useTranslate from '~/hooks/useTranslate';

interface Props {
  alignMenuRight?: boolean;
  hasSiblings?: boolean;
  showText?: boolean;
}

const MainMenu: React.FC<Props> = ({
  alignMenuRight,
  hasSiblings,
  showText = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const onMainMenuClicked = () => {
    setIsOpen(!isOpen);
    if (!isOpen && ref && ref.current) {
      ref.current.focus();
    }
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const t = useTranslate();

  return (
    <MainMenuContainer
      alignMenuRight={alignMenuRight}
      hasSiblings={hasSiblings}
      onBlur={closeMenu}
      ref={ref}
      tabIndex={0}
      data-cy={menuOpenButton}
    >
      {isOpen ? (
        <>
          {showText ? (
            <Button variant="tertiary" onClick={onMainMenuClicked}>
              {t('Close')}
            </Button>
          ) : (
            <ActionIcon
              onClick={onMainMenuClicked}
              icon="close"
              style={{
                background: 'none',
              }}
            />
          )}
          <MenuItems onMenuItemClick={closeMenu} />
        </>
      ) : (
        <>
          {showText ? (
            <Button
              variant="tertiary"
              onClick={onMainMenuClicked}
              onMouseDown={(e) => e.preventDefault()}
            >
              {t('Menu')}
            </Button>
          ) : (
            <>
              <ActionIcon
                onClick={onMainMenuClicked}
                onMouseDown={(e) => e.preventDefault()}
                icon="menu"
                style={{
                  background: 'none',
                }}
              />
            </>
          )}
        </>
      )}
    </MainMenuContainer>
  );
};

export default MainMenu;
